import React from "react";
import { CheckIcon, GlobeIcon, LockIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { CountdownTimer } from "../CountdownTimer";
import { ScarcityBar } from "../ScarcityBar";
import { images, includedResources } from "../../data/content";
const perks = ["6 Practical Volumes", "5 Professional Bonuses", "Immediate Digital Delivery", "Reusable Clinical Organization Tools", "7-Day Money-Back Guarantee"];
export function Offer() {
  return <section id="offer" className="bg-plum-950 px-4 py-14 sm:py-20" data-id="element-230" data-mp="3f4a3mffc2lp9">
      <div className="mx-auto max-w-2xl" data-id="element-231" data-mp="3f2feeox147fd">
        <h2 className="text-center font-display text-[28px] font-extrabold leading-tight text-white sm:text-4xl" data-id="element-232" data-mp="3jv069kwdkag9">
          Your Complete Pediatric Feeding Therapy Toolkit Is Ready
        </h2>
        <p className="mt-3 text-center text-lg font-semibold text-mint-300" data-id="element-233" data-mp="3swggnsn6wckh">
          Get All 6 Practical Volumes + 5 Professional Bonuses for Just $27
        </p>

        <div className="mt-8 overflow-hidden rounded-3xl bg-white shadow-2xl ring-4 ring-mint-400" data-id="element-234" data-mp="1napppgecysc">
          <div className="bg-mint-500 px-4 py-3 text-center font-display text-lg font-extrabold text-plum-950" data-id="element-235" data-mp="1kj3vxlmtmzws">
            PEDIATRIC FEEDING THERAPY BLUEPRINT™
          </div>
          <img src={images.mockup} alt="Complete digital collection" className="block w-full" loading="lazy" data-id="element-236" data-mp="1bl1zlje18vfu" />

          <div className="px-4 pb-6 sm:px-6" data-id="element-237" data-mp="16ns2riobdhhz">
            <div className="flex items-center justify-between border-b-2 border-plum-100 py-3 text-xs font-extrabold text-plum-700" data-id="element-238" data-mp="23c7qrabrzisz">
              <span data-id="element-239" data-mp="1zaw7dmjhvtt8">INCLUDED RESOURCES</span>
              <span data-id="element-240" data-mp="1ujeapaoi8fe2">ACCESS</span>
            </div>
            <ul className="divide-y divide-plum-50" data-id="element-241" data-mp="1ui36xav277my">
              {includedResources.map(r => <li key={r.label} className="flex items-start justify-between gap-3 py-2.5" data-id="element-242" data-mp="1pk1kcfyfcq6q">
                  <span className="text-sm font-medium text-slate-800" data-id="element-243" data-mp="2n1i6upffo5rm">{r.label}</span>
                  <span className={`shrink-0 rounded-full px-2.5 py-0.5 text-xs font-extrabold ${r.access === "FREE" ? "bg-sun text-plum-950" : "bg-mint-100 text-mint-700"}`} data-id="element-244" data-mp="2i8gno5871k28">
                    {r.access}
                  </span>
                </li>)}
            </ul>

            <p className="mt-4 text-center text-sm font-extrabold text-plum-700" data-id="element-245" data-mp="2we8vvbvxm0hx">11 PRACTICAL DIGITAL RESOURCES</p>

            <div className="mt-4 rounded-2xl bg-plum-50 p-5 text-center" data-id="element-246" data-mp="2iepxvbwu45jc">
              <p className="text-sm font-extrabold text-plum-700" data-id="element-247" data-mp="2ndsvwceedbht">TODAY’S PRICE</p>
              <p className="font-display text-6xl font-extrabold text-cta" data-id="element-248" data-mp="2nbpxb3z6ia1h">$27</p>
              <p className="text-sm font-bold text-slate-700" data-id="element-249" data-mp="29ge10s5dkbig">USD · One Payment. Immediate Digital Access.</p>
              <p className="text-xs text-slate-500" data-id="element-250" data-mp="2dhpuj8rddgvx">No recurring subscription required.</p>
              <p className="mx-auto mt-3 flex w-fit items-center gap-1.5 rounded-full bg-white px-3 py-1.5 text-xs font-bold text-plum-800 ring-1 ring-plum-200" data-id="element-251" data-mp="7ktvki9uod8f">
                <GlobeIcon className="h-4 w-4 text-mint-600" aria-hidden="true" data-id="element-252" data-mp="1w7lw63e8g4hq" />
                Currency is converted automatically to your local currency
              </p>
            </div>

            <ScarcityBar data-id="element-253" data-mp="25xf8j6m78nn1" />

            <div className="mt-5" data-id="element-254" data-mp="25xyhvyxsa3pg">
              <CtaButton label="Yes! I Want My Complete Feeding Therapy Blueprint for $27" data-id="element-255" data-mp="215ngernea9us" />
            </div>

            <CountdownTimer data-id="element-256" data-mp="2fubaethlebim" />

            <ul className="mx-auto mt-5 grid max-w-xl gap-2 sm:grid-cols-2" data-id="element-257" data-mp="2ft8hkg0plz02">
              {perks.map(p => <li key={p} className="flex items-start gap-2 text-sm font-semibold text-slate-800" data-id="element-258" data-mp="2auykfzvfcobt">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-mint-600" aria-hidden="true" data-id="element-259" data-mp="2oupxnye4a0or" />
                  {p}
                </li>)}
            </ul>
            <p className="mt-4 flex items-center justify-center gap-1.5 text-xs font-semibold text-slate-500" data-id="element-260" data-mp="ui9s6zt5aqky">
              <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-261" data-mp="pjf8zwr9n00b" />
              Secure checkout · Encrypted payment
            </p>
          </div>
        </div>
      </div>
    </section>;
}